import { createLoading } from "../../../utils/loading";
import store from "../../../store/index";
import { defineAsyncComponent, reactive, toRaw } from "vue";
import lodash from "lodash";
import { checkAttribute, initUseForm, onClickCreate, onClickEdit, onClickView } from "../../../utils/form";
import { validateError } from "../../../utils/validate";

import { has } from "../../../utils/menu-context";
import { flatWhereGroup } from "../../../utils/search";
import {
    createForm,
    createRules,
    onClickRequest,
    validate
} from "../license-request/request/license/request-license.logic";

import {
    createColumns,
    createField,
    createFieldAppealLicense,
    createFieldLicenseCondition,
    createFieldLicenseStatus,
    createFieldPrintStatus,
    createFieldProposeRevoke,
    createReportItems,
    createLogAdminCommandDetail,
} from "./license.section";

import {
    createAppPageHeaderTop,
    createManageExportCsv,
    createManageSelect,
    createPage,
    createRowActionEdit,
    createRowActionView
} from "../../../utils/page";
import { createConditionAction, createConditionForm } from "./license.condition";
import { useForm as createUseForm } from "@ant-design-vue/use";
import { setAppPageHeader } from "../../../components/layout/app-layout/app-layout.logic";
import { createButton, createButtonCreate, createButtonEdit, createButtonView } from "../../../utils/button";

import { Col, Row } from "ant-design-vue";
import i18n from "../../../i18n";
import { createButtonDropdown } from "../../../utils/dropdown";
import { openModalForm as openModalFormConfirmRequest } from "../license-request/modal/confirm-request.logic";

export const CIcon = defineAsyncComponent(() => import("../../../components/icon/CIcon"));

export const { isLoading, setIsLoading } = createLoading();
export const actionPrefix = "resource/v1/transaction/licenseRequest";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria });

export const onSearch = ({ props, page, state }) => {
    const where = page.where || [];
    const sort = page.sort || [];
    const customWhere = lodash.cloneDeep(where);
    setIsLoading(true);
    window.onSearch?.({ page });
    return callSearch({ criteria: { ...page, data: [], where: [...customWhere, ...createWhereFor({ props })], sort } })
        .then(page => (state.page = { ...page, where, sort }))
        .finally(() => setIsLoading(false));
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const createWhereFor = ({ props }) => {
    const { menuContext } = props;
    const whereGroup = [];
    const userInfo = store.state.resource.auth.info?.user;
    const userDepartment = store.state.resource.auth.info?.department;

    /* Control การมองเห็นตามสิทธิ์  */
    // เห็นทั้งหมด
    const isOfficer = has({ menuContext, key: "forReviewRequest"})
        || has({ menuContext, key: "forLawyerAuditor"})
        || has({ menuContext, key: "forRDAuditor"})
        || has({ menuContext, key: "forDofCenter"})
        || has({ menuContext, key: "forAuthorized"})

    if (!has({ menuContext, key: "viewOnlyInProvince"})
        && !has({ menuContext, key: "viewOnlyInAmphur" })
        && isOfficer
    ) {
        console.log(""); // ห้ามลบ !!!!!!!!
    }
    // เห็นแค่ในจังหวัดและอำเภอภายในจังหวัด โดยเทียบข้อมูลในคำขอ ส่วนของหน่วยรับคำขอ ที่ตรงกับสังกัดของเจ้าหน้าที่ และสังกัดลูกของเจ้าหน้าที่
    else if (has({ menuContext, key: "viewOnlyInProvince" }) && isOfficer) {
        whereGroup.push([{ name: "refReceiveDept.refProvince.id", type: "UUID", operator: "=", value: userDepartment?.refProvince?.id }])
    }
    // เห็นแค่ในจังหวัด โดยเทียบข้อมูลในคำขอ ส่วนของหน่วยรับคำขอ ที่ตรงกับสังกัดของเจ้าหน้าที่
    else if (has({ menuContext, key: "viewOnlyInAmphur" }) && isOfficer) {
        whereGroup.push([{ name: "refReceiveDept.refAmphur.id", type: "UUID", operator: "=", value: userDepartment?.refAmphur?.id }])
    }
    // เห็นได้เฉพาะที่ตัวเองสร้าง
    else if (has({ menuContext, key: "viewOnlyMe" }) && !isOfficer) {
        whereGroup.push([{ name: "refOwner.username", type: "String", operator: "=", value: userInfo.username }]);
    }

    //
    //
    // if (has({ menuContext, key: "forRequest" })) {
    //     const where = [{ name: "createBy", type: "UUID", operator: "=", value: userInfo.id }];
    //     whereGroup.push(where);
    // }
    return [{ name: "isTemp", type: "Boolean", operator: "=", value: false }, ...flatWhereGroup({ where: whereGroup, logic: "OR" })];
};

export const createFormTitle = ({ data }) => {
    const modelRef = data.useForm.modelRef;
    return modelRef.licenseCode +  (modelRef.refLicenseStatus ? " (" + modelRef.refLicenseStatus?.value + ")": "");
};

export const createSearchOneCriteria = ({ props, id, forLog }) => {
    if (!forLog) {
        return {
            select: [
                "**", "refRequester.**"
            ],
            isDistinct: false,
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id },  ...createWhereFor({ props })],
            children: [
                {
                    name: "addresses",
                    select: ["*", "refAddressType.*", "refProvince.*", "refAmphur.*", "refTambon.*"],
                    page: 0,
                    size: 1,
                    where: [
                        { name: "refId", type: "UUID", operator: "=", value: id },
                        { name: "model", type: "String", operator: "=", value: "LicenseRequest" }
                    ]
                },
                {
                    name: "addressOwners",
                    select: ["*", "refAddressType.*", "refProvince.*", "refAmphur.*", "refTambon.*"],
                    page: 0,
                    size: 1,
                    where: [
                        { name: "refId", type: "UUID", operator: "=", value: id },
                        { name: "model", type: "String", operator: "=", value: "LicenseOwner" }
                    ],
                },
                {
                    name: "refVesselRequest.vesselOwnerRequests",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                    children: []
                },
                {
                    name: "refVesselRequest.attachmentVesselIdentities",
                    select: ["*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }]
                },
                {
                    name: "refVesselRequest.attachmentPositionVesselIdentities",
                    select: ["*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }]
                },
                {
                    name: "refVesselRequest.attachmentHeadVessels",
                    select: ["*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }]
                },
                {
                    name: "refVesselRequest.attachmentFullVessels",
                    select: ["*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }]
                },
                {
                    name: "fishingToolRequests",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                    children: []
                },
                {
                    name: "licenseRequestInspections",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "refInspectionTopic.seq", type: "ASC" }],
                    children: [
                        {
                            name: "children",
                            select: ["*", "refLicenseRequest.*", "refInspectionTopic.*", "refParent.*"],
                            page: 0,
                            size: 1000000
                        }
                    ]
                },
                {
                    name: "feeStatements",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                    children: []
                },
                {
                    name: "attachmentFeeSlips",
                    select: ["*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                    children: []
                },
                {
                    name: "attachmentReviewRequests",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    where: [
                        { name: "refId", type: "UUID", operator: "=", value: id },
                        { name: "group", type: "String", operator: "=", value: "ReviewRequest" },
                    ]

                },
                {
                    name: "attachmentLawyers",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    where: [
                        { name: "refId", type: "UUID", operator: "=", value: id },
                        { name: "group", type: "String", operator: "=", value: "Lawyer" },
                    ]

                },
                {
                    name: "attachmentArgueLawyers",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [
                        { name: "refId", type: "UUID", operator: "=", value: id },
                        { name: "group", type: "String", operator: "=", value: "ArgueLawyer" },
                    ]

                },
                {
                    name: "attachmentDofCenters",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [
                        { name: "refId", type: "UUID", operator: "=", value: id },
                        { name: "group", type: "String", operator: "=", value: "DofCenter" },
                    ]

                },
                {
                    name: "attachmentDirectors",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [
                        { name: "refId", type: "UUID", operator: "=", value: id },
                        { name: "group", type: "String", operator: "=", value: "DofCenter" },
                    ]

                },
                {
                    name: "attachmentCancelRequests",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [
                        { name: "refId", type: "UUID", operator: "=", value: id },
                        { name: "group", type: "String", operator: "=", value: "CancelLicenseRequestAttachment" },
                    ]

                },
                {
                    name: "attachmentAppealRequests",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    where: [
                        { name: "refId", type: "UUID", operator: "=", value: id },
                        { name: "group", type: "String", operator: "=", value: "AppealRequestAttachment" },
                    ]
                },
                {
                    name: "licenseSuspendedHistories",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                    children: [
                        {
                            name: "administrativeCommandDetails",
                            select: ["**"],
                            page: 0,
                            size: 1000000,
                        },
                        {
                            name: "attachments",
                            select: ["**"],
                            page: 0,
                            size: 1000000,
                        },
                    ],
                },
            ]
        };
    } else {
        return {
            select: [],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }],
            children: []
        };
    }
};




export const loadForm = ({ props, data, refs }) => {
    setIsLoading(true);
    const { form } = props;
    const { id, useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else if (id) {
        promise = callSearch({ criteria: createSearchOneCriteria({ props, data, refs, id }) });
    } else {
        promise = Promise.resolve({ data: [useForm.modelRef] });
    }
    return promise
        .then(page => initUseForm({ props, data, refs, page }))
        .then(() => loadDefaultForm({ props, data, refs }))
        .then(() => initUseForm({ props, data, refs, page: { data: [modelRef] } }))
        .finally(() => setIsLoading(false));
};

export const loadDefaultForm = () => {
    const promises = [];
    return Promise.all(promises);
};

export const initState = ({ props }) => {
    const { menuContext, routerPrefix } = props;
    state.manages = [createManageSelect({ menuContext }), createManageExportCsv({ menuContext })];
    state.manageExtras = [];
    state.rowActions = [
        createRowActionView({
            menuContext,
            onClick: ({ record }) => {
                onClickView({ record,  routerPrefix });
            },
        }),
        createRowActionEdit({
            menuContext,
            onClick: ({ record }) => {
                onClickEdit({ record, routerPrefix });
            },
            visible: ({ record }) => state.conditionAction.canEdit({ props, record }) && !["cancel","expired"].includes(record?.refLicenseStatus?.key),
        }),
    ];
};

export const initForm = ({ props, data, refs }) => {
    const { routerPrefix } = props;
    checkAttribute({ props, data, refs });
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fieldPrintStatus = createFieldPrintStatus({ props, data, refs, isLoading, visibleStatus: ["waitPrintedLicense", "printedLicense"] });
    data.fields = createField({ props, data, refs, isLoading });
    data.fieldLicenseCondtion =  createFieldLicenseCondition({ props, data, refs, isLoading });
    data.fieldProposeRevoke = createFieldProposeRevoke({ props, data, refs, isLoading });
    data.fieldLicenseRevokeResultStatus = createFieldLicenseStatus({ props, data, refs, isLoading, visibleStatus: ["revoke", "active"]
        , title: i18n.global.t("views.license.revokeDetail"),
        fieldKey: "revokeResult"
    });
    data.fieldLicensSuspendedResultStatus = createFieldLicenseStatus({ props, data, refs, isLoading, visibleStatus: ["active", "suspend"],
        title: i18n.global.t("views.license.suspendDetail"),
        invisibleFields: ["licenseRevokeRemark", "attachmentRevokes"],
        fieldKey: "suspendedResult"
    });
    data.fieldLicensAllResultStatus = createFieldLicenseStatus({ props, data, refs, isLoading,
        title: i18n.global.t("views.license.licenseStatusDetail"),
        visibleStatus: ["active", "suspend", "revoke"],
        invisibleFields: ["licenseRevokeRemark", "attachmentRevokes"],
        fieldKey: "allStatusResult"
    });
    data.fieldAppealLicense = createFieldAppealLicense({ props, data, refs, isLoading });
    // data.fieldAdminCommand = createFieldAdminCommand({ props, data, refs, isLoading })
    data.conditionForms = createConditionForm({ props, data, refs, isLoading });
    data.logAdminCommandDetail = createLogAdminCommandDetail({ props, data, refs });
    loadForm({ props, data, refs }).then(() => {
        if (props.setAppPageHeader) {
            setAppPageHeader({
                slots: {
                    top: () => createAppPageHeaderTop({ props, data, refs, state, routerPrefix, onClickView, onClickEdit }),
                    default: () => createAppPageHeaderDefault({ props, data, refs })
                }
            });
        }
    });
};

export const createAppPageHeaderDefault = ({ props, data, refs }) => {
    const col1 = [];
    const col2 = [];
    const colCenter = [];
    const { menuContext, viewOnly, routerPrefix } = props;
    const { useForm } = data;
    const { modelRef, initialModel } = useForm;
    const { id, isActive } = modelRef;
    const canEdit = state.conditionAction.canEdit({ props, record: initialModel });
    const canAppealLicense = state.conditionAction.canAppealLicense({ props, record: initialModel });

    if (id && has({ menuContext, key: "canCreate" })) {
        col1.push(createButtonCreate({ onClick: () => onClickCreate({ routerPrefix }), classStyle: "m-1" }));
    }
    if (!viewOnly && id && has({ menuContext, key: "canView" })) {
        col1.push(createButtonView({ onClick: () => onClickView({ record: { id }, routerPrefix }), classStyle: "m-1" }));
    }
    if (viewOnly && id && isActive && canEdit) {
        col1.push(createButtonEdit({ onClick: () => onClickEdit({ record: { id }, routerPrefix }), classStyle: "m-1" }));
    }
    if (!viewOnly && (!id || (id && isActive && canEdit))) {
        col1.push(
            createButton({
                text: `${i18n.global.t("button.save")} `,
                classStyle: `m-1 btn-primary`,
                onClick: () => {
                    validate({ props, data, refs }).then(() => {
                        onClickRequest({
                            props,
                            data,
                            refs,
                            formParams: {},
                            otp: null,
                            successText: i18n.global.t("views.license.saveLicenseSuccess")
                        });
                    });
                },
                icon: viewOnly ? null : <CIcon file="save.svg"></CIcon>
            })
        )
    }
    if (viewOnly && (id && isActive)) {
        colCenter.push(
            createButtonDropdown({
                text: i18n.global.t("button.print"),
                items: createReportItems({ props, modelRef, id })
            })
        )
    }

    /* ส่วนของการขออุทธรณ์คำขอ */
    if (viewOnly && (id && isActive) && canAppealLicense) {
        col2.push(
            createButton({
                text: `${i18n.global.t("button.appealRequest")}`,
                classStyle: `m-1 btn-danger`,
                onClick: () => {
                    Promise.resolve()
                    .then(() => data.isSendRequest = true)
                    .then(() => {
                        validate({ props, data, refs }).then(() => {
                            openModalFormConfirmRequest({
                                okText: i18n.global.t("button.appealLicense"),
                                props: { ...props, modalMessage: i18n.global.t("views.request.licenseRequest.modal.confirmAppeal")},
                                data,
                                onOk: () => {
                                    Promise.resolve()
                                    .then(() => data.useForm.modelRef.isHaveAppealedLicense = true)
                                    .then(() => {
                                        onClickRequest({
                                            props,
                                            data,
                                            refs,
                                            formParams: {},
                                            otp: null,
                                            isSendRequest: data.isSendRequest,
                                            successText: i18n.global.t("views.request.licenseRequest.sentAppeal")
                                        });
                                    })
                                }
                            });
                        })
                    })
                },
            })
        )
    }



    return (
        <Row type="flex">
            <Col span="11">{col1}</Col>
            <Col span="1">{colCenter}</Col>
            <Col class="ml-auto">{col2}</Col>
        </Row>
    );
};

export const state = reactive({
    columns: createColumns(),
    page: createPage({
        options: {
            select: [
                "**"
            ],
            sort: [{ name: "updateDate", type: "DESC" }]
        }
    }),
    tableOptions: { search: { activeKey: "Search" } },
    conditionAction: createConditionAction()
});